import { FC, useEffect, useRef, useState } from "react";
import { ChatState } from "../../types";
import { useChatStore, useThemeStore, useUserStore } from "../../../../stores";
import { CHAT_PAGE_ROOM_IDX, SIDE_PANEL_ROOM_IDX } from "../../../../constants";
import MyChat from "./my-chat";
import OthersChat from "./others-chat";
import { Heading } from "../../../../components/typography";

let componentMountCount = 0;

const ChatBodyChats: FC<ChatState> = ({ isSidePanel, setEditingChat }) => {
  const theme = useThemeStore((s) => s.theme);
  const user = useUserStore((s) => s.user);
  const { chats, selectedRooms, setSelectedRoom, rooms, nextPage } =
    useChatStore();

  const SELECTED_ROOM_IDX = isSidePanel
    ? SIDE_PANEL_ROOM_IDX
    : CHAT_PAGE_ROOM_IDX;

  useEffect(() => {
    if (!selectedRooms[SELECTED_ROOM_IDX] && rooms.length) {
      setSelectedRoom(SELECTED_ROOM_IDX, rooms[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rooms, selectedRooms[SELECTED_ROOM_IDX]]);

  const rootRef = useRef<HTMLDivElement>(null);
  const endRef = useRef<HTMLDivElement>(null);
  const beginRef = useRef<HTMLDivElement>(null);
  const firstChatRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (
      (document.querySelector(".chat") as HTMLDivElement) !==
      firstChatRef.current
    ) {
      if (!componentMountCount) {
        componentMountCount++;
        return;
      }
      firstChatRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [chats]);

  useEffect(() => {
    if (!chats[selectedRooms[SELECTED_ROOM_IDX]?._id.$oid || ""]?.length)
      return;

    let el = document.querySelector(".chat");
    if (el === firstChatRef.current) return;

    while (!el) {
      el = document.querySelector(".chat");
    }
    firstChatRef.current = el as HTMLDivElement;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chats, rooms, selectedRooms[SELECTED_ROOM_IDX]]);

  useEffect(() => {
    if (!isAtBottom) return;

    setTimeout(() => {
      if (!endRef.current) return;
      endRef.current.scrollIntoView({ behavior: "smooth" });
    }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chats]);

  const [isAtBottom, setIsAtBottom] = useState<boolean>(true);

  useEffect(() => {
    if (!beginRef.current || !rootRef.current || !endRef.current) return;

    let i = 0;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === beginRef.current) {
              if (!i) return i++;
              nextPage(SELECTED_ROOM_IDX);
            } else if (entry.target === endRef.current) {
              setIsAtBottom(true);
            }
          } else {
            if (entry.target === beginRef.current) {
            } else if (entry.target === endRef.current) {
              setIsAtBottom(false);
            }
          }
        });
      },
      {
        root: rootRef.current,
        rootMargin: "0px",
        threshold: 1,
      }
    );

    observer.observe(beginRef.current);
    observer.observe(endRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beginRef, rootRef, endRef]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
      }}
      ref={rootRef}
    >
      <div ref={beginRef} style={{ marginBottom: "10rem" }}></div>
      <Heading
        textStyles={{
          marginBottom: "1rem",
          widows: "100%",
          textAlign: "center",
        }}
        color={theme.textOnBg}
      >
        برای بارگیری بیشتر اسکرول کنید
      </Heading>
      {chats[selectedRooms[SELECTED_ROOM_IDX]?._id.$oid || ""] ? (
        chats[selectedRooms[SELECTED_ROOM_IDX]?._id.$oid || ""]?.map((chat) =>
          chat.from.$oid === user?._id.$oid ? (
            <MyChat
              key={chat._id.$oid}
              chat={chat}
              isSidePanel={isSidePanel}
              setEditingChat={setEditingChat}
            />
          ) : (
            <OthersChat
              key={chat._id.$oid}
              chat={chat}
              isSidePanel={isSidePanel}
            />
          )
        )
      ) : (
        <></>
      )}
      <div ref={endRef}></div>
    </div>
  );
};

export default ChatBodyChats;
